import React, { useState, useEffect } from "react";
import { notification } from "antd";
import "./Gift.css";
import AddGift from "../../AddGift/AddGift";
import Edit from "../../../assets/edit.png";
import Deleteicon from "../../../assets/delete.png";
import EditGift from "../../EditGift/EditGift";
import DeleteGift from "../../DeleteGift/DeleteGift";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore"; // Firebase imports
import { db } from "../../../firebase-config";

const Gift = () => {
  const [displayCount, setDisplayCount] = useState(5);
  const [gifts, setGifts] = useState([]);
  const [selectedGiftId, setSelectedGiftId] = useState("");

  const [showAddGift, setShowAddGift] = useState(false);
  const [showEditGift, setShowEditGift] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const fetchGifts = async () => {
    const querySnapshot = await getDocs(collection(db, "gifts")); // Fetch data from 'gifts' collection
    const giftsData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setGifts(giftsData); // Set the fetched gifts to state
  };
  useEffect(() => {
    fetchGifts();
  }, []);
  // Empty dependency array to fetch data once on component mount

  const handleLoadMore = () => {
    setDisplayCount(displayCount + 5);
  };

  const handleAddGift = () => {
    setShowAddGift(true);
  };

  const handleEditGift = (id) => {
    setSelectedGiftId(id); // Set the selected gift ID
    setShowEditGift(true); // Show the edit modal
  };

  const handleDeleteClick = (id) => {
    setSelectedGiftId(id); // Set the selected gift ID
    setShowDelete(true); // Show the delete modal
  };

  const handleCloseEditGift = () => {
    setShowEditGift(false);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
  };

  const handleCloseAddGift = () => {
    setShowAddGift(false);
  };

  // function to delete
  const deleteSelectedGiftId = async () => {
    try {
      const giftRef = doc(db, "gifts", selectedGiftId);
      await deleteDoc(giftRef);
      setGifts(gifts.filter((gift) => gift.id !== selectedGiftId));
      setShowDelete(false); // Close the delete modal
      notification.success({
        message: "Gift deleted successfully",
        description: `Successful`,
        placement: "topRight",
        duration: 3,
      });
    } catch (error) {
      notification.error({
        message: "Error deleting gift",
        description: `${error.message}`,
        placement: "topRight",
        duration: 3,
      });
    }
  };

  return (
    <div className="Gift">
      <div className="sl">
        <h1 className="heading">Gift</h1>
        <div className="btn" onClick={handleAddGift}>
          Add New Gift
        </div>
      </div>
      <div className="tb">
        <div className="tablecon">
          <table className="table" cellSpacing={0}>
            <thead className="tablehead">
              <tr>
                <th>ID</th>
                <th>Gift Name</th>
                <th>Expired On</th>
                <th>Coin Required</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="tablebody">
              {gifts.slice(0, displayCount).map((gift) => (
                <tr key={gift.id}>
                  <td>{gift.id}</td>
                  <td>{gift.giftName}</td>
                  <td>{gift.expiryDate}</td>
                  <td>{gift.coinRequired}</td>
                  <td className="btns">
                    <img
                      onClick={() => handleEditGift(gift.id)}
                      src={Edit}
                      alt="Edit"
                    />
                    <img
                      onClick={() => handleDeleteClick(gift.id)}
                      src={Deleteicon}
                      alt="Delete"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {gifts.length > displayCount && (
        <div className="load-more">
          <button onClick={handleLoadMore}>Load More</button>
        </div>
      )}

      {showAddGift && (
        <AddGift
          showAddGift={showAddGift}
          fetchGifts={fetchGifts}
          setShowAddGift={setShowAddGift}
          closeDelete={handleCloseAddGift}
        />
      )}
      {showEditGift && (
        <EditGift
          showEditGift={showEditGift}
          fetchGifts={fetchGifts}
          closeEditGift={handleCloseEditGift}
          selectedGiftId={selectedGiftId}
        />
      )}

      {showDelete && (
        <DeleteGift
          showDelete={showDelete}
          fetchGifts={fetchGifts}
          closeDelete={handleCloseDelete}
          onDeleteClick={deleteSelectedGiftId}
        />
      )}
    </div>
  );
};

export default Gift;
